export interface DressSortListProps {
    selectedValue?: DressSortType;
    handleSortSelection: (sortType: DressSortType) => void;
}

export type DressSortType = 0 | 1 | 2 | 3;
const UNKNOWN_SORT_TYPE: DressSortType = 0;
const LOWER_PRICE: DressSortType = 1;
const UPPER_PRICE: DressSortType = 2;
const NAME: DressSortType = 3;

export const DressSortTypeValues = {
    UNKNOWN: UNKNOWN_SORT_TYPE,
    LOWER_PRICE,
    UPPER_PRICE,
    NAME,
};
